import type { ReactElement } from 'react';
import { CompetitorSources } from './CompetitorSources.tsx';

export const SOURCES_SHORTCUTS: [string, string][] = [['g then f', 'Go to Competitor sources (1–4 switch its sections)']];

export function sourcesPage(path: string): ReactElement | null {
  if (path === '/competitor-sources') return <CompetitorSources />;
  return null;
}
